// import axios from "axios";

// const getBaseURL = () => {
//     if (typeof process !== "undefined" && process.env && process.env.VITE_API_BASE_URL) {
//         return process.env.VITE_API_BASE_URL;
//     }
//     try {
//         if ( process.env && process.env &&  process.env.VITE_API_BASE_URL) {
//             return  process.env.VITE_API_BASE_URL;
//         }
//     } catch (e) {}
//     return "http://localhost:8000/api";
// };

// const ApiService = axios.create({
//     baseURL: getBaseURL(),
//     headers: {
//         "Content-Type": "application/json",
//     },
// });

// ApiService.interceptors.request.use((config) => {

//     const token = localStorage.getItem("token");

//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
// });

//  ApiService.interceptors.response.use(
//     (response) => response,
//     (error) => {

//         if (error.response) {

//             if (error.response.status === 401) {
//                 debugger
//                 localStorage.removeItem("token");
//                 localStorage.removeItem("user");
//                 localStorage.removeItem("role");

//                 window.location.href = "/";
//             }

//             if (error.response.status === 403) {

//                 window.location.href = "/error";
//             }
//         }

//         return Promise.reject(error);
//     }
// );

// export default ApiService;

import axios from "axios";

const ApiService = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api",
    headers: {
        "Content-Type": "application/json",
    },
});
 

ApiService.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

ApiService.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                localStorage.removeItem("role");
                window.location.href = "/";
            }
            if (error.response.status === 403) {
                window.location.href = "/error";
            }
        }
        return Promise.reject(error);
    }
);

export default ApiService;